<template>
  <path
    fill="currentColor"
    d="M6 19.5h3V18h1.5c.425 0 .781-.144 1.07-.432.287-.288.431-.644.43-1.068V12c0-.425-.144-.781-.432-1.068A1.459 1.459 0 0 0 10.5 10.5H6V9h6V6H9V4.5H6V6H4.5c-.425 0-.781.144-1.068.432A1.459 1.459 0 0 0 3 7.5V12c0 .425.144.781.432 1.07.288.287.644.431 1.068.43H9V15H3v3h3v1.5Zm12 .875 3-7h-6l3 7ZM15 11h6l-3-7-3 7Z"
  />
</template>
